// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3LGjQ","description":"PatientConsentPreview_description__3peJe"};